module.exports = __webpack_public_path__ + "img/mini-027.a5908254.jpg";